function serializeForInlineScript(value: string): string {
  return JSON.stringify(value).replace(/</g, '\\u003c');
}

export function getHotpadsPxParamUpdateScriptContents(userToken: string): string {
  return `window._pxParam4 = ${serializeForInlineScript(userToken)};`;
}

export function setHotpadsPxParam(userToken: string): void {
  if (typeof window === 'undefined') return;
  (window as Window & { _pxParam4?: string })._pxParam4 = userToken;
}
